/* flow */
import React, { PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import { CustomInput } from './DatePicker'

type Props = {
  date: string,
  changeDate: (date: Date) => void
}

class ListDatePicker extends PureComponent<Props> {

  handleChange = date => {
    const { changeDate } = this.props
    date && changeDate(date.toDate())
  }
 
  render () {
    const { date } = this.props
    return (
      <div className='ac-list__datepicker'>
        <DatePicker
          customInput={<CustomInput />}
          selected={date ? moment(date) : moment()}
          maxDate={moment()}
          onChange={this.handleChange}
        />
      </div>
    )
  }
}

export default ListDatePicker





// WEBPACK FOOTER //
// ./src/ListDatePicker.js